/* PNGS */
import MobileWhatsappBackground from './pngs/mobile-whatsapp-background.png';
import ProfileIcon from './pngs/profile-icon.png';
import StatusBarIcons from './pngs/status-bar-icons.png';
import ZonoMoneySimulatorFooter from './pngs/zono-money-footer.png';
import ZonoMoneySimulatorHeader from './pngs/zono-money-header.png';

/* SVGS */
import AddBlackIcon from './svgs/add-black-icon.svg?url';
import AddBlueIcon from './svgs/add-blue-icon.svg?url';
import AddGreenIcon from './svgs/add-green-icon.svg?url';
import BackBlackIcon from './svgs/back-black-icon.svg?url';
import BackBlueIcon from './svgs/back-blue-icon.svg?url';
import CheckGreenIcon from './svgs/check-green-icon.svg?url';
import CloseGreyIcon from './svgs/close-grey-icon.svg?url';
import ErrorFillIcon from './svgs/error-fill-icon.svg?url';
import InfoFillIcon from './svgs/info-fill-icon.svg?url';
import InfoFillWhiteIcon from './svgs/info-fill-white-icon.svg?url';
import RadioSelected from './svgs/radio-selected.svg?url';
import RadioUnSelected from './svgs/radio-unselected.svg?url';
import SendBlueIcon from './svgs/send-blue-icon.svg?url';
import SendGreenIcon from './svgs/send-green-icon.svg?url';
import SendOutlinedIcon from './svgs/send-outlined-icon.svg?url';
import StickersBlackIcon from './svgs/stickers-black-icon.svg?url';
import StickersBlueIcon from './svgs/stickers-blue-icon.svg?url';
import UploadColorIcon from './svgs/upload-color-icon.svg?url';
import QuestionBlueIcon from './svgs/question-blue-icon.svg?url';
import WhatsappWhiteIcon from './svgs/whatsapp-white-icon.svg?url';

export const JTBD_PNGS = {
  MobileWhatsappBackground,
  ProfileIcon,
  StatusBarIcons,
  ZonoMoneySimulatorFooter,
  ZonoMoneySimulatorHeader,
};

export const JTBD_SVGS = {
  AddBlackIcon,
  AddBlueIcon,
  AddGreenIcon,
  BackBlackIcon,
  BackBlueIcon,
  CheckGreenIcon,
  CloseGreyIcon,
  ErrorFillIcon,
  InfoFillIcon,
  InfoFillWhiteIcon,
  RadioSelected,
  RadioUnSelected,
  SendBlueIcon,
  SendGreenIcon,
  SendOutlinedIcon,
  StickersBlackIcon,
  StickersBlueIcon,
  UploadColorIcon,
  QuestionBlueIcon,
  WhatsappWhiteIcon,
};
